<template>
  <div class="bread-container">
    <Breadcrumb>
      <BreadcrumbItem v-for="item in breadcrumb" :key="item.path">
        <a v-if="item.path" :href="item.path">{{ item.title }}</a>
        <span v-else>{{ item.title }}</span>
      </BreadcrumbItem>
    </Breadcrumb>
    <!-- 返回按钮 -->
    <Button type="text" icon="ios-arrow-back" @click="handleBack">返回</Button>
  </div>
</template>
<script>
import { Breadcrumb, BreadcrumbItem, Button } from "iview";
export default {
  name: "Bread",
  components: {
    Breadcrumb,
    BreadcrumbItem,
  },
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleBack() {
      const { breadcrumb } = this;
      if (breadcrumb.length > 1) {
        location.replace(breadcrumb[breadcrumb.length - 2].path);
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>
<style scoped>
.bread-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
}
</style>
<style>
.bread-container .ivu-btn-text {
  color: #1677ff;
  font-size: 14px;
  padding-top: 0;
  padding-bottom: 0;
}
.bread-container .ivu-icon {
  font-size: 20px;
}
</style>
